import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const hotcommentApi = {
  show (params) {
    // 获取show下热门评论（按赞数达标时间排序，不按赞数排序）
    return axios.get(`${ApiSetting.baseUrl}/api/hotcomments/show/`, {params: params})
  }
}

export default hotcommentApi
